module.exports = __webpack_public_path__ + "static/media/arterite1.51e06710.jpg";